import React from 'react';
import {optionId} from "../../utils/utils";
import {Field} from 'redux-form';

const RadioField = ({name, options, disabled=false
        }) => {
    const handleClick = () => {}
    const optionId = (option) => option.value

    return <>
        {options.map((option, index) => (
            <div key={index}>
                <div className="custom-control custom-radio">
                    <Field component="input" type="radio" name={name} className="custom-control-input" id={`radio_${name}_${optionId(option)}`} value={option.value.toString()} disabled={disabled} onClick={handleClick}/>
                    <label className="custom-control-label p-0 m-0" htmlFor={`radio_${name}_${optionId(option)}`}>{option.label}</label>&nbsp;
                </div>
            </div>
        ))}
    </>
};

export default RadioField;